import React, { useEffect } from 'react'
import { PhoneVerificationForm } from './PhoneVerificationForm'
import UserFooter from './UserComponent/UserFooter'
import UserHeader from './UserComponent/UserHeader'

export const PhoneVerification = () => {

//   useEffect(() => {
//     const handleBeforeUnload = (event) => {
//         localStorage.clear();
//     };
//     window.addEventListener('beforeunload', handleBeforeUnload);

//     return () => {
//         window.removeEventListener('beforeunload', handleBeforeUnload);
//     };
// }, []);
window.onbeforeunload = () => {
  localStorage.clear();
}

  return (
    <div className='formBody'>
      <UserHeader />
      <PhoneVerificationForm />
      <UserFooter />
    </div>
  )
}
